export default "__VITE_ASSET__Dz3ygJ71__"